// extracted by mini-css-extract-plugin
export default {"wrapper":"Metrics_wrapper__EUH-p","metric":"Metrics_metric__L18wi","desc":"Metrics_desc__yDAEy"};